import styled, { css } from 'styled-components';
import { Input } from '@rebass/forms';

import { theme } from '../../styles/theme';
import isDarkColour from '../../utils/isDarkColour';

const FormInput = styled(Input)`
  &&& {
    font-size: 16px;
    line-height: 1;
    border: 1px solid currentColor;
    border-radius: 0;
    background-color: transparent;
    padding: 0.75em 0.75em 0.5em;
    height: 38px;
    outline-color: transparent;
  }
`;

export default FormInput;
